import React, { FC, useState } from 'react'
import { PopoverProps, PopoverImage, AnnotationImage } from './Popover.types'
import './css/Popover.scss'
import TourImage from './components/TourImage'
import FocusArea from './components/FocusArea'
import { sanitizeHTML } from '../../../shared/utils/common-utils.js'
import MobileAccordion from './components/MobileAccordion'

const Popover: FC<PopoverProps> = props => {
  const {
    heading,
    description,
    popoverImageList,
    hero,
    previousButton,
    previousLink,
    nextButton,
    nextLink,
  } = props.content
  const [activeAnnotation, setActiveAnnotation] = useState<number | null>(null)
  const [numberAnnotations] = useState<number>(() => {
    let runningCount: number = 0
    popoverImageList?.forEach(popoverImage => {
      runningCount += popoverImage.annotationList?.length || 0
    })
    return runningCount
  })

  const openFirst = (event: React.MouseEvent) => {
    event.stopPropagation()
    setActiveAnnotation(1)
  }
  let index = 0
  return (
    <>
      {hero && (
        <div className='u-sizeConstrained u-paddingVert40'>
          <h2
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(heading),
            }}
          />
          <p
            className='u-paddingTop8 u-paddingBottom48'
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(description),
            }}
          />
          <button
            onClick={openFirst}
            className='Button Button--primary'
            data-analytics='RIG-reset-tool'
            aria-label={'Start statement tour'}>
            Start statement tour
          </button>
        </div>
      )}

      <div className='u-bgColorLight u-paddingVert40'>
        <div className='u-sizeConstrained'>
          {!hero && (
            <>
              <h2
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(heading),
                }}
              />
              <p
                className='u-paddingTop8 u-paddingBottom48'
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(description),
                }}
              />
            </>
          )}

          {popoverImageList.map((currentImage: PopoverImage) => {
            return (
              <>
                <TourImage
                  src={currentImage.popoverImage}
                  alt={currentImage.imageAlt}
                  key={currentImage.id}>
                  {currentImage.annotationList?.map((currentAnnotation: AnnotationImage) => {
                    index++
                    const hasPrevious: boolean = index !== 1
                    const hasNext: boolean = index < numberAnnotations
                    return (
                      <FocusArea
                        top={currentAnnotation.top}
                        left={currentAnnotation.left}
                        height={currentAnnotation.height}
                        width={currentAnnotation.width}
                        key={currentAnnotation.id}
                        dialogPosition={currentAnnotation.dialogPosition}
                        index={index}
                        tour={{
                          currentFocusArea: activeAnnotation,
                          setCurrentFocusArea: setActiveAnnotation,
                          hasPrevious,
                          hasNext,
                        }}>
                        <h3
                          dangerouslySetInnerHTML={{
                            __html: sanitizeHTML(currentAnnotation.heading),
                          }}
                        />
                        <p
                          dangerouslySetInnerHTML={{
                            __html: sanitizeHTML(currentAnnotation.description),
                          }}
                        />
                      </FocusArea>
                    )
                  })}
                </TourImage>
                <MobileAccordion
                  annotationList={currentImage.annotationList}
                  key={`${currentImage.id}-accordion`}
                />
              </>
            )
          })}
          <nav className='PagePagination' role='navigation' aria-label='Pagination'>
            <div className='u-sizeConstrained'>
              <ul className='u-flex u-flexCol u-md-flexRow u-lg-flexRow u-flexJustifyBetween'>
                <li className='u-sizeFull u-md-sizeAuto u-lg-sizeAuto u-sm-marginVert8'>
                  {previousLink && previousButton && (
                    <a
                      className='Button Button--primary Button--small u-sizeFull u-md-sizeAuto u-lg-sizeAuto'
                      href={previousLink}
                      aria-label={previousButton}>
                      {previousButton}
                    </a>
                  )}
                </li>
                <li className='u-sizeFull u-md-sizeAuto u-lg-sizeAuto u-sm-marginVert8'>
                  {nextLink && nextButton && (
                    <a
                      className='Button Button--primary Button--small u-sizeFull u-md-sizeAuto u-lg-sizeAuto'
                      href={nextLink}
                      aria-label={nextButton}>
                      {nextButton}
                    </a>
                  )}
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  )
}
export default Popover
